import { render, staticRenderFns } from "./MoU.vue?vue&type=template&id=c0ffa4e8&"
import script from "./MoU.vue?vue&type=script&lang=js&"
export * from "./MoU.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports